import socratesBust from '@/assets/socrates-philosopher-bust.png'

interface StreakIndicatorProps {
  streak: number // positive = win streak, negative = loss streak, 0 = draw
}

export function StreakIndicator({ streak }: StreakIndicatorProps) {
  if (streak >= 4) {
    return (
      <span className="streak-fire" title={`${streak} wins in a row!`}>
        <span className="streak-fire__flames">
          <span className="streak-fire__blur">
            <span className="streak-fire__flame-big"></span>
          </span>
          <span className="streak-fire__spark"></span>
          <span className="streak-fire__spark"></span>
          <span className="streak-fire__spark"></span>
          <span className="streak-fire__spark"></span>
          <span className="streak-fire__blur streak-fire__blur--fix">
            <span className="streak-fire__flame"></span>
          </span>
        </span>
        <img src={socratesBust} alt={`${streak} wins in a row!`} className="streak-fire__icon" />
      </span>
    )
  }
  if (streak === 3) {
    return (
      <span className="text-red-500 dark:text-red-400 text-sm font-bold" title="3 wins in a row">
        ↑
      </span>
    )
  }
  if (streak === 2) {
    return (
      <span className="text-yellow-500 dark:text-yellow-400 text-sm font-bold" title="2 wins in a row">
        ↗
      </span>
    )
  }
  if (streak <= -3) {
    return (
      <span className="text-zinc-400 dark:text-zinc-500 text-sm font-bold" title={`${Math.abs(streak)} losses in a row`}>
        ↓
      </span>
    )
  }
  if (streak === -2) {
    return (
      <span className="text-blue-500 dark:text-blue-400 text-sm font-bold" title="2 losses in a row">
        ↘
      </span>
    )
  }
  return null
}
